import { AXDecoratorModule } from '@acorex/components/decorators';
import { AXDrawerComponent, AXDrawerModule } from '@acorex/components/drawer';
import { AXEventService } from '@acorex/core/events';
import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, ElementRef, ViewChild, ViewEncapsulation, afterNextRender, inject, viewChild } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { EventActions } from '@travel/shared/enums';
import { LinkService, ScrollToTopService, SharedService } from '@travel/shared/services';
import { DrawerMenuComponent } from './components/drawer-menu/hotel-wl-drawer-menu.component';
import { HotelWlFooterComponent } from './components/footer/hotel-wl-footer.component';
import { HotelHeaderComponent } from './components/header/hotel-wl-header.component';

@Component({
  selector: 'travel-btc-workspace-hotel-wl-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HotelWlFooterComponent, HotelHeaderComponent, AXDrawerModule, AXDecoratorModule, DrawerMenuComponent],
  templateUrl: './hotel-wl-layout.component.html',
  styleUrl: './hotel-wl-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [ScrollToTopService],
})
export class HotelWlLayoutComponent {
  @ViewChild('d') drawer!: AXDrawerComponent;
  drawerContainer = viewChild<any>('dc');
  div = viewChild<ElementRef<HTMLDivElement>>('div');
  @ViewChild('test', { static: false }) test!: any;

  drawerContainerClasses = '';
  eventService: AXEventService = inject(AXEventService);
  navigated = false;

  constructor(private _router: Router, private readonly linkService: LinkService, private sharedService: SharedService, private viewportScroller: ViewportScroller) {
    afterNextRender(() => {
      this.scrollTo();
    });

    this.eventService.on('SCROLL_TO', () => {
      this.scrollTo();
    });

    // مشخص نمودن navigated or reloaded
    this.checkNavigatedOrReload();

    // انتخاب کنونیکال
    this.linkService.startRouteListener();

    this.eventService.on(EventActions.toggleDrawerMenu, () => {
      this.drawer.toggle();
    });
  }

  scrollTo() {
    this.div()?.nativeElement.scrollTo({ top: 0 });
  }
  // check navigated or reloaded
  checkNavigatedOrReload() {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // 'The user navigated from another page
        if (event.navigationTrigger === 'popstate' || event.navigationTrigger === 'imperative') {
          this.navigated = true;
        } else {
          this.navigated = false;
        }
      }
    });
  }
}
